import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Appt Components
import ResponsiveGrid from '../../../components/compound/responsiveGrid/ResponsiveGrid.js'
import Box from '../../../components/simple/box/Box.js'
import Divider from '../../../components/simple/divider/Divider.js'
import Text from '../../../components/simple/text/Text.js'

// App widgets

// Shared Components

import { Bar } from 'react-chartjs-2';
import SimpleCounter from '../../../components/compound/simpleCounter/SimpleCounter';

import LocalStorageService from '../../../services/LocalStorageService.js'
import { backgroundColours, borderColours } from '../common/colours.js'

const ConcernReport = props => {
  const navigate = useNavigate();
  const terms = LocalStorageService.get('terms');

  const [concernByStudent, setconcernByStudent] = useState([]);
  const [concernByType, setconcernByType] = useState([]);
  const [concernCount, setconcernCount] = useState([]);
  const [concernStudentCount, setconcernStudentCount] = useState([]);
  const [concernByStudentPositive, setconcernByStudentPositive] = useState([]);
  const [concernByStudentNegative, setconcernByStudentNegative] = useState([]);
  const [concernByStudentNA, setconcernByStudentNA] = useState([]);
  const [concernSearch, setconcernSearch] = useState([]);



  const [concernByTypeData, setconcernByTypeData] = useState([]);
  const [concernStudentOverview, setconcernStudentOverview] = useState([]);

  const [numSuspendedStudents, setSupendedStudents] = useState([]);

  // const [summary, setSummary] = useState([]);
  const [relatedIncidents, setRelatedConcerns] = useState([]);

  // Incidents by Student Group
   const summary = {
     labels: concernByType?.map(item => item?.response),
     datasets: [
       {
         data: concernByType?.map(item => item?.count),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };


   const students = {
     labels: concernStudentOverview?.map(item => `${item?.studentFirstname || ''} ${item?.studentLastname || ''}`),
     datasets: [
       {
         data: concernStudentOverview?.map(item => item?.count),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };

   const studentsPositive = {
     labels: concernByStudentPositive?.map(item => `${item?.studentFirstname || ''} ${item?.studentLastname || ''}`),
     datasets: [
       {
         data: concernByStudentPositive?.map(item => item?.count),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };

   const studentsNegative = {
     labels: concernByStudentNegative?.map(item => `${item?.studentFirstname || ''} ${item?.studentLastname || ''}`),
     datasets: [
       {
         data: concernByStudentNegative?.map(item => item?.count),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };

   const studentsNA = {
     labels: concernByStudentNA?.map(item => `${item?.studentFirstname || ''} ${item?.studentLastname || ''}`),
     datasets: [
       {
         data: concernByStudentNA?.map(item => item?.count),
         backgroundColor: backgroundColours,
         borderColor: borderColours,
         borderWidth: 1,
       },
     ],
   };
   

  const printScreen = () => {
    window.print();
  };

  useEffect(() => {

    if (props?.reportData?.concernByStudent) {
      setconcernByStudent(props?.reportData?.concernByStudent);
    }

    if (props?.reportData?.concernByType) {
      setconcernByType(props?.reportData?.concernByType);
    }

    if (props?.reportData?.concernCount) {
      setconcernCount(props?.reportData?.concernCount);
    }

    if (props?.reportData?.concernStudentCount) {
      setconcernStudentCount(props?.reportData?.concernStudentCount);
    }

    if (props?.reportData?.concernStudentOverview) {
      setconcernStudentOverview(props?.reportData?.concernStudentOverview);
    }

    if (props?.reportData?.concernByStudentPositive) {
      setconcernByStudentPositive(props?.reportData?.concernByStudentPositive);
    }

    if (props?.reportData?.concernByStudentNegative) {
      setconcernByStudentNegative(props?.reportData?.concernByStudentNegative);
    }

    if (props?.reportData?.concernByStudentNA) {
      setconcernByStudentNA(props?.reportData?.concernByStudentNA);
    }

    if (props?.reportData?.concernByStudentNA) {
      setconcernByStudentNA(props?.reportData?.concernByStudentNA);
    }

    if (props?.reportData?.concernSearch) {
      setconcernSearch(props?.reportData?.concernSearch);
    }
  
  }, [props.reportData]);

  return (
    <Box width='xlarge' gap='medium' margin={{ bottom: 'medium' }}>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['50%', '50%'],
            medium: ['50%', '50%'],
            large: ['50%', '50%'],
            xlarge: ['50%', '50%'],
          }}
          gap="small"
          pad="xxsmall"
        >
          <SimpleCounter
            count={
              props?.reportData?.concernCount?.[0]?.count
                ? String(props.reportData.concernCount[0].count)
                : '0'
            }
            label="Total Count"
          />
          <SimpleCounter
            count={
              props?.reportData?.concernStudentCount?.[0]?.count
                ? String(props.reportData.concernStudentCount[0].count)
                : '0'
            }
            label="Number Students"
          />
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['100%'],
            medium: ['100%'],
            large: ['100%'],
            xlarge: ['100%'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              Communications Summary
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {summary?.length !== 0 ? (
              <Bar
                data={summary}
                height={25}
                legend={{ display: false }}
                // options={{ maintainAspectRatio: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = 'positiveNegative';
                  let value = props?.reportData?.concernByType?.[_index]?.response

                  if (value === 'N/A') {
                    props.addFilters([
                      { key: 'positiveNegative', response: 'Negative', operator: 'is not' },
                      { key: 'positiveNegative', response: 'Positive', operator: 'is not' }
                    ])
                  } else {
                    props.addFilter(key, value);
                  }

                }}
                width={'100%'}
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>

         <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['100%'],
            medium: ['100%'],
            large: ['100%'],
            xlarge: ['100%'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              {terms?.serviceUser?.charAt(0)?.toUpperCase() + terms?.serviceUser?.slice(1)} Summary
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {students?.length !== 0 ? (
              <Bar
                data={students}
                height={25}
                legend={{ display: false }}
                // options={{ maintainAspectRatio: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = 'studentName';
                  let value = props?.reportData?.concernStudentOverview?.[_index]?.studentID
                  props.addFilter(key, value);

                }}
                width={'100%'}
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>


        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['100%'],
            medium: ['100%'],
            large: ['100%'],
            xlarge: ['100%'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              Positive Communications
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {studentsPositive?.length !== 0 ? (
              <Bar
                data={studentsPositive}
                height={25}
                legend={{ display: false }}
                // options={{ maintainAspectRatio: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = 'studentName';
                  let value = props?.reportData?.concernByStudentPositive?.[_index]?.studentID
                  props.addFilters([
                    { key: 'studentName', value: value, operator: 'is' },
                    { key: 'positiveNegative', value: 'Positive', operator: 'is' }
                  ])

                }}
                width={'100%'}
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>

        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['100%'],
            medium: ['100%'],
            large: ['100%'],
            xlarge: ['100%'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              Negative Communications
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {studentsNegative?.length !== 0 ? (
              <Bar
                data={studentsNegative}
                height={25}
                legend={{ display: false }}
                // options={{ maintainAspectRatio: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = 'studentName';
                  let value = props?.reportData?.concernByStudentNegative?.[_index]?.studentID
                  props.addFilters([
                    { key: 'studentName', value: value, operator: 'is' },
                    { key: 'positiveNegative', value: 'Negative', operator: 'is' }
                  ])

                }}
                width={'100%'}
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>

        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['100%'],
            medium: ['100%'],
            large: ['100%'],
            xlarge: ['100%'],
          }}
          gap="small"
        >
          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              N/A Communications
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {studentsNA?.length !== 0 ? (
              <Bar
                data={studentsNA}
                height={25}
                legend={{ display: false }}
                // options={{ maintainAspectRatio: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = 'studentName';
                  let value = props?.reportData?.concernByStudentNA?.[_index]?.studentID
                  props.addFilters([
                    { key: 'studentName', value: value, operator: 'is' },
                    { key: 'positiveNegative', value: 'Positive', operator: 'is not' },
                    { key: 'positiveNegative', value: 'Negative', operator: 'is not' }
                  ])

                }}
                width={'100%'}
              />
            ) : (
              <Text textAlign="center">Not enough data available</Text>
            )}
          </Box>
        </ResponsiveGrid>
        
    </Box>
  );
};

export default ConcernReport;
